import { CONFIG } from 'shared/config';

export const ENDPOINTS = {
  AUTH: `${CONFIG.AUTH_API_URL}`,
  USERS: `${CONFIG.AUTH_API_URL}/users`,
  IMPERSONATE: `${CONFIG.TALENT_API_URL}/users`,
  REFRESH_TOKEN: `${CONFIG.AUTH_API_URL}/refresh_token`,
  RESET_PASSWORD: `${CONFIG.AUTH_API_URL}/v1/reset_password`,
  RESET_PASSWORD_CHECKER: `${CONFIG.AUTH_API_URL}/v1/reset_password_token_checker`,
  CHANGE_PASSWORD: `${CONFIG.AUTH_API_URL}/change_password`,
  RESEND_VERIFICATION: `${CONFIG.AUTH_API_URL}/resend_confirmation_email`,
  PROVIDER_AUTHENTICATION: `${CONFIG.AUTH_API_URL}/provider_authentication`,
  ME: `${CONFIG.TALENT_API_URL}/me`,
  AGENCY_ACCESS_CODE: `${CONFIG.TALENT_API_URL}/validate_agency_access_code`,
  PROFESSION: `${CONFIG.TALENT_API_URL}/professions`,
  SENDER_INFO: `${CONFIG.TALENT_API_URL}/sender_details`,
  GUARDIAN: `${CONFIG.TALENT_API_URL}/guardians`,
  PROFILE: `${CONFIG.TALENT_API_URL}/profiles`,
  CLAIM_MULTIPLE_PROFILES: `${CONFIG.TALENT_API_URL}/claim_profiles`,
  MULTIPLE_PROFILE: `${CONFIG.TALENT_API_URL}/multiple_profiles`,
  AGENCY: `${CONFIG.TALENT_API_URL}/agencies`,
  MEDIA: `${CONFIG.UPLOAD_API_URL}/media`,
  PRESIGNED_URL: `${CONFIG.UPLOAD_API_URL}/presigned_url`,
  MEDIA_URLS: `${CONFIG.UPLOAD_API_URL}/media_urls`,
  ACCOUNT: `${CONFIG.TALENT_API_URL}`,
  TALENTS: `${CONFIG.TALENT_API_URL}/talents`,
  COMPANY: `${CONFIG.TALENT_API_URL}/public_company`,
  ADDRESS: `${CONFIG.TALENT_API_URL}/talents/addresses`,
  QUESTION: `${CONFIG.TALENT_API_URL}/questions`,
  CASTING_LOCATION: `${CONFIG.TALENT_API_URL}/casting_locations`,
  SCHEDULES_SESSIONS: `${CONFIG.TALENT_API_URL}/schedules_sessions`,
  PROJECT: `${CONFIG.TALENT_API_URL}/projects`,
  FIREBASE: `${CONFIG.TALENT_API_URL}/firebase`,
  GRAPHQL: CONFIG.GRAPHQL_API_URL,
  UPLOAD: `${CONFIG.UPLOAD_API_URL}/media`,
  SESSION: `${CONFIG.TALENT_API_URL}/sessions`,
  AUDITION_SCHEDULES: `${CONFIG.TALENT_API_URL}/audition_schedules`,
  VERIFY_AUDITION: `${CONFIG.TALENT_API_URL}/public/check_in_verifications`,
  GOOGLE_MAPS: `${CONFIG.TALENT_API_URL}/google_maps`,
  MEDIA_TAGS: `${CONFIG.TALENT_API_URL}/media_tags`,
  OPPORTUNITY_TAB_AGGREGATES: `${CONFIG.TALENT_API_URL}/talents/opportunity_aggregates`,
  OPPORTUNITY_PUBLIC_AGGREGATES: `${CONFIG.TALENT_API_URL}/talents/public_opportunity_aggregates`,
  OPPORTUNITY_REMOVE_PROJECT: `${CONFIG.TALENT_API_URL}/talents/hide_opportunities`,
  OPPORTUNITY_APPLY: `${CONFIG.TALENT_API_URL}/talents/opportunity_submissions`,
  AUDITION_CHECKER: `${CONFIG.TALENT_API_URL}/talent_audition_checker`,
  CALENDAR_EVENT_AGGREGATES: `${CONFIG.TALENT_API_URL}/calendar_event_aggregates`,
  CALENDAR_EVENTS: `${CONFIG.TALENT_API_URL}/calendar_events`,
  COMPANY_MATCHES: `${CONFIG.TALENT_API_URL}/match_casting_companies`,
  AGENCY_TALENT_LIBRARY_AGGREGATES: `${CONFIG.TALENT_API_URL}/agency_talent_library_aggregates`,
  GUARDIAN_ATTACH: `${CONFIG.TALENT_API_URL}/guardians_attach_talents`,
  INVITE_TALENT: `${CONFIG.TALENT_API_URL}/new_representation_request`,
  PLAYLIST: `${CONFIG.TALENT_API_URL}/profile_playlists`,
  CARS_VEHICHLE_TYPE: `https://us-central1-talent-web-dev.cloudfunctions.net/api/vehicle-types`,
  FIRESTORE: `${CONFIG.TALENT_API_URL}/firestore/audition_request_messages`,
  CARS_MANUFACTURER: `https://us-central1-talent-web-dev.cloudfunctions.net/api/cars/manufacturers`,
  CARS_MODEL: `https://us-central1-talent-web-dev.cloudfunctions.net/api/cars/models`,
  CARS_VARIANT: `https://us-central1-talent-web-dev.cloudfunctions.net/api/cars/variants`,
  CARS_SINGLE_VARIANT: `https://us-central1-talent-web-dev.cloudfunctions.net/api/cars/variant`,
  PETS_ANIMAL: 'https://us-central1-talent-web-dev.cloudfunctions.net/api/pets/animals',
  PETS_BREED: 'https://us-central1-talent-web-dev.cloudfunctions.net/api/pets/breeds',
  PETS_SIZE: 'https://us-central1-talent-web-dev.cloudfunctions.net/api/pets/size',
};
